import appStore from 'store';
import api from './api';

const store = {
    namespaced: true,
    state:{
        listInfo:[],
        total:0,
    },
    mutations:{
        setListInfo(state,payload) {
            state.listInfo = payload;
        },
        setTotal(state,payload) {
            state.total = payload;
        }
    },
    actions:{
        buildList({commit},data) {
            api.getMarketList(data).then(response => {
                commit('setTotal',response.data.totalCount);
                commit('setListInfo',response.data.list);
            })
        }
    }
}

appStore.registerModule('marketMaker',store);
